import Vue from 'vue'
import App from './App.vue'
import router from './router'


// Create EventBus instance
export const EventBus = new Vue();

// Make EventBus globally available
Vue.prototype.$eventBus = EventBus;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
